export default "__VITE_ASSET__noiDSTbz__"